import React, { useState, useEffect, useRef } from "react";
import { storage } from "../../config/fb_config";
import "./DocumentCard.css";
import {
  PICK_IMAGE,
  UPLOAD_IMAGE,
  UPLOAD_SUCCESS,
} from "../../utils/imagepath";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

export default function DocumentCard({ callBackFn, documentData, sf_id }) {
  console.log("sf_id-- ", sf_id);
  console.log("document card data -- -", documentData);

  const [file, setFile] = useState(null);
  const fileInput = useRef(null);
  const [fileName, setFileName] = useState("");
  const [docUrl, setDocUrl] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);

  useEffect(() => {
    if (uploadProgress === 100) {
      setIsSubmitting(false);
      console.log("All documents uploaded");
    }
  }, [uploadProgress]);

  function handleChange(event) {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  }

  const handlePickImage = () => {
    fileInput.current.click();
    setIsUploaded(false);
  };

  const handleUpload = () => {
    if (!file) {
      alert("Please upload file first!");
      return;
    }

    setIsSubmitting(true);

    const storageRef = ref(storage, `/${sf_id}/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const percent = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setUploadProgress(percent);
      },
      (err) => {
        console.log(err);
        setIsSubmitting(false);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {
          console.log(url);
          setDocUrl(url);
          callBackFn(documentData.doc_name, url, documentData.sf_id);
          setIsUploaded(true);
          alert("File uploaded successfully!");
        });
      }
    );
  };

  return (
    <div>
      {documentData ? (
        <div className="document-card">
          <div>
            <input
              type="file"
              onChange={handleChange}
              accept="image/*,application/pdf"
              style={{ display: "none" }}
              ref={fileInput}
            />

            <button
              onClick={handlePickImage}
              disabled={
                !(
                  documentData.status === "Pending" ||
                  documentData.status === "Rejected"
                )
              }
            >
              <div>
                <img src={PICK_IMAGE} alt="Pick" className="img_pick" />
                <div className="img_add">Add</div>
              </div>
            </button>
          </div>

          <div style={{ width: "calc(100% - 2rem)", paddingLeft: "0.25rem" }}>
            <h3 className={documentData.is_required ? "doc_text" : ""}>
              {documentData.doc_name}
              {documentData.is_required ? (
                <span style={{ fontSize: "15px", color: "red" }}>
                  {" "}
                  (Required) *
                </span>
              ) : (
                <span style={{ fontSize: "13px", color: "gray" }}>
                  {" "}
                  (Optional)
                </span>
              )}
            </h3>

            <div
              style={{
                display: "flex",
                paddingBottom: "0.5rem",
                color: "#424242",
                fontSize: "0.625rem",
                lineHeight: "1rem",
                fontWeight: "600",
                paddingTop: "0.25rem",
              }}
            >
              <div>
                Status:
                <span
                  style={{
                    paddingLeft: "0.25rem",
                    color:
                      isUploaded || documentData.status === "Uploaded"
                        ? "green"
                        : documentData.status === "Rejected"
                        ? "red"
                        : "green",
                  }}
                >
                  {isUploaded ? "Uploaded" : documentData.status}
                </span>
              </div>
            </div>

            <div style={{ display: "flex" }}>
              {fileName && (
                <div
                  style={{
                    color: "#0047FF",
                    paddingRight: "1rem",
                    fontSize: "0.6875rem",
                    lineHeight: "1rem",
                    fontWeight: "500",
                    textDecoration: "underline",
                  }}
                >
                  {fileName}
                </div>
              )}
            </div>
          </div>

          {(documentData.status === "Pending" ||
            documentData.status === "Rejected") && (
            <div>
              <button onClick={handleUpload} disabled={isSubmitting}>
                {uploadProgress === 100 && isUploaded ? (
                  <img src={UPLOAD_SUCCESS} alt="upload" />
                ) : (
                  <img src={UPLOAD_IMAGE} alt="upload" />
                )}
              </button>
            </div>
          )}
        </div>
      ) : (
        <p style={{ padding: "32%" }}>No Document related to this record id.</p>
      )}

      {uploadProgress > 0 && uploadProgress < 100 && (
        <div style={{ marginTop: "1rem" }}>
          <progress value={uploadProgress} max="100"></progress>
        </div>
      )}
    </div>
  );
}


// import React, { useState, useEffect, useRef } from "react";
// import { storage } from "../../config/fb_config";
// import "./DocumentCard.css";
// import {
//   PICK_IMAGE,
//   UPLOAD_IMAGE,
//   UPLOAD_SUCCESS,
// } from "../../utils/imagepath";
// import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

// export default function DocumentCard({
//   callBackFn,
//   documentData,
//   sf_id,
//   newDocUpload = false,
// }) {
//   console.log("sf_id-- ", sf_id);
//   console.log("document card data -- -", documentData);

//   const [file, setFile] = useState(null);
//   const fileInput = useRef(null);
//   const [fileName, setFileName] = useState("");
//   const [docUrl, setDocUrl] = useState("");
//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isUploaded, setIsUploaded] = useState(false);

//   useEffect(() => {
//     if (uploadProgress === 100) {
//       setIsSubmitting(false);
//       console.log("All documents uploaded");
//     }
//   }, [uploadProgress]);

//   function handleChange(event) {
//     const selectedFile = event.target.files[0];
//     if (selectedFile) {
//       setFile(selectedFile);
//       setFileName(selectedFile.name);
//     }
//   }

//   const handlePickImage = () => {
//     fileInput.current.click();
//     setIsUploaded(false);
//   };

//   const handleUpload = () => {
//     if (!file) {
//       alert("Please upload file first!");
//       return;
//     }

//     setIsSubmitting(true);

//     const storageRef = newDocUpload
//       ? ref(storage, `/new_documents/${sf_id}/${file.name}`)
//       : ref(storage, `${sf_id}/${file.name}`);

//     const uploadTask = uploadBytesResumable(storageRef, file);

//     uploadTask.on(
//       "state_changed",
//       (snapshot) => {
//         const percent = Math.round(
//           (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
//         );
//         setUploadProgress(percent);
//       },
//       (err) => {
//         console.log(err);
//         setIsSubmitting(false);
//       },
//       () => {
//         getDownloadURL(uploadTask.snapshot.ref).then((url) => {
//           console.log(url);
//           setDocUrl(url);
//           if (!newDocUpload) {
//             callBackFn(documentData.doc_name, url, documentData.sf_id);
//           }
          
//           console.log(
//             "document upload info ",
//             "doc_name - ",
//             documentData.doc_name,
//             " url - ",
//             url,
//             " sf_id - ",
//             documentData.sf_id,
//           );

//           setIsUploaded(true);
//           alert("File uploaded successfully!");
//         });
//       },
//     );
//   };

//   return (
//     <div>
//       {documentData ? (
//         <div className="document-card">
//           <div>
//             <input
//               type="file"
//               onChange={handleChange}
//               accept="image/*,application/pdf"
//               style={{ display: "none" }}
//               ref={fileInput}
//             />

//             <button
//               onClick={handlePickImage}
//               disabled={
//                 newDocUpload
//                   ? ""
//                   : !(
//                       documentData.status === "Pending" ||
//                       documentData.status === "Rejected"
//                     )
//               }
//             >
//               <div>
//                 <img src={PICK_IMAGE} alt="Pick" className="img_pick" />
//                 <div className="img_add">Add</div>
//               </div>
//             </button>
//           </div>

//           <div style={{ width: "calc(100% - 2rem)", paddingLeft: "0.25rem" }}>
//             <h3 className={documentData.is_required ? "doc_text" : ""}>
//               {documentData.doc_name}
//               {documentData.is_required ? (
//                 <span style={{ fontSize: "15px", color: "red" }}>
//                   {" "}
//                   (Required) *
//                 </span>
//               ) : (
//                 <span style={{ fontSize: "13px", color: "gray" }}>
//                   {" "}
//                   (Optional)
//                 </span>
//               )}
//             </h3>

//             <div
//               style={{
//                 display: "flex",
//                 paddingBottom: "0.5rem",
//                 color: "#424242",
//                 fontSize: "0.625rem",
//                 lineHeight: "1rem",
//                 fontWeight: "600",
//                 paddingTop: "0.25rem",
//               }}
//             >
//               <div>
//                 Status:{" "}
//                 {newDocUpload ? (
//                   ""
//                 ) : (
//                   <span
//                     style={{
//                       paddingLeft: "0.25rem",
//                       color:
//                         isUploaded || documentData.status === "Uploaded"
//                           ? "green"
//                           : documentData.status === "Rejected"
//                             ? "red"
//                             : "green",
//                     }}
//                   >
//                     {isUploaded ? "Uploaded" : documentData.status}
//                   </span>
//                 )}
//                 pending
//               </div>
//             </div>

//             <div style={{ display: "flex" }}>
//               {fileName && (
//                 <div
//                   style={{
//                     color: "#0047FF",
//                     paddingRight: "1rem",
//                     fontSize: "0.6875rem",
//                     lineHeight: "1rem",
//                     fontWeight: "500",
//                     textDecoration: "underline",
//                   }}
//                 >
//                   {fileName}
//                 </div>
//               )}
//             </div>
//           </div>

//           {newDocUpload ? (
//             <div>
//               <button onClick={handleUpload} disabled={isSubmitting}>
//                 {uploadProgress === 100 && isUploaded ? (
//                   <img src={UPLOAD_SUCCESS} alt="upload" />
//                 ) : (
//                   <img src={UPLOAD_IMAGE} alt="upload" />
//                 )}
//               </button>
//             </div>
//           ) : (
//             (documentData.status === "Pending" ||
//               documentData.status === "Rejected") && (
//               <div>
//                 <button onClick={handleUpload} disabled={isSubmitting}>
//                   {uploadProgress === 100 && isUploaded ? (
//                     <img src={UPLOAD_SUCCESS} alt="upload" />
//                   ) : (
//                     <img src={UPLOAD_IMAGE} alt="upload" />
//                   )}
//                 </button>
//               </div>
//             )
//           )}
//         </div>
//       ) : (
//         <p style={{ padding: "32%" }}>No Document related to this record id.</p>
//       )}

//       {uploadProgress > 0 && uploadProgress < 100 && (
//         <div style={{ marginTop: "1rem" }}>
//           <progress value={uploadProgress} max="100"></progress>
//         </div>
//       )}
//     </div>
//   );
// }
